import { BASE_URL } from '../../../../../utils/config.base-url'

export const TASK_TAG_PREFIX_URL = '/task-tag'
export const URL_ENDPOINT_TASK_TAG = `${BASE_URL}/task-tag`
